<template>
  <div class="gs_container">
    <div class="gs_crumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item
          ><span class="local">你的位置</span></el-breadcrumb-item
        >
        <el-breadcrumb-item>代付模块</el-breadcrumb-item>
        <el-breadcrumb-item>自有账户</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="search-box">
      <div class="item">
        商户ID：
      </div>
      <div class="item w1">
        <el-select v-model="form.MerchantId" filterable size="small">
          <el-option
            v-for="item in view.merchantIdList"
            :key="item"
            :label="item"
            :value="item"
          >
          </el-option>
        </el-select>
      </div>
      <div class="item">
        <el-button type="danger" size="small" @click="search()">查询</el-button>
        <el-button size="small" @click="reset()">重置</el-button>
        <el-button size="small" @click="$router.push('/home/selfAccountAdd')"
          >新增</el-button
        >
      </div>
    </div>
    <div class="tips"></div>
    <el-table
      ref="singleTable"
      :data="tableData"
      highlight-current-row
      border
      style="width: 100%"
    >
      <el-table-column type="index" width="50" align="center">
      </el-table-column>
      <el-table-column
        property="applicationUserId"
        label="商户ID"
        align="center"
      >
      </el-table-column>
      <el-table-column property="overMoney" label="账户余额" align="center">
      </el-table-column>
      <el-table-column
        property="settlementType"
        label="提现助手重置类型"
        align="center"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.settlementType == 0">T0</span>
          <span v-else>T1</span>
        </template>
      </el-table-column>
      <el-table-column property="appId" label="应用ID" align="center">
      </el-table-column>
      <el-table-column property="state" label="状态" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.state == 1">正常</span>
          <span v-else>
            <font color="#ff0000">禁用</font>
          </span>
        </template>
      </el-table-column>
      <el-table-column property="modifiedTime" label="更新时间" align="center">
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button
            type="text"
            size="small"
            @click="jinyong(scope.$index, scope.row)"
          >
            <span v-if="scope.row.state == 1">禁用</span>
            <span v-else>正常</span>
          </el-button>
          <el-button
            type="text"
            size="small"
            @click="xiugai(scope.$index, scope.row)"
          >
            <span v-if="scope.row.settlementType == 1">改T0</span>
            <span v-else>改T1</span>
          </el-button>
          <!-- <el-button type="text" size="small" @click="dialogConfig=true">查看</el-button> -->
          <el-button
            type="text"
            size="small"
            @click="
              $router.push(
                '/home/selfAccountEdit?id=' +
                  scope.row.id +
                  '&userId=' +
                  scope.row.applicationUserId
              )
            "
            >修改</el-button
          >
          <el-button
            type="text"
            size="small"
            @click="
              dialogRefund = true;
              applicationUserId = scope.row.applicationUserId;
            "
            >退款</el-button
          >

          <el-dropdown style="margin-left: 10px;" @command="handleCommand">
            <el-button type="text" size="small">类型</el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                :command="{ type: 1, userid: scope.row.applicationUserId }"
                >自有账户</el-dropdown-item
              >
              <el-dropdown-item
                :command="{ type: 2, userid: scope.row.applicationUserId }"
                >平台账户</el-dropdown-item
              >
              <el-dropdown-item
                :command="{ type: 0, userid: scope.row.applicationUserId }"
                >线下账户</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
    <div class="mgt15 mgb15 mgl15 mgr15" style="text-align: center;">
      <el-pagination
        background
        layout="prev, pager, next"
        :total="form.total"
        :current-page="form.PageNumber"
        :page-size="form.PageSize"
        @current-change="changePage"
      >
      </el-pagination>
    </div>
    <!-- 自由账户配置 -->
    <el-dialog title="自由账户配置" :visible.sync="dialogConfig">
      <el-table
        ref="singleTable"
        :data="tableData"
        highlight-current-row
        border
        style="width: 100%"
        size="small"
      >
        <el-table-column type="index" width="50" align="center">
        </el-table-column>
        <el-table-column property="name" label="修改前" align="center">
        </el-table-column>
        <el-table-column property="name" label="修改后" align="center">
        </el-table-column>
        <el-table-column property="name" label="修改时间" align="center">
        </el-table-column>
        <el-table-column property="name" label="操作人" align="center">
        </el-table-column>
      </el-table>
    </el-dialog>
    <!-- 退款 -->
    <el-dialog
      title="请输入退还至商户账户余额的金额"
      :visible.sync="dialogRefund"
      width="20%"
    >
      <el-form ref="form" :model="refound" :rules="rules">
        <el-form-item prop="money">
          <el-input v-model="refound.money"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('form')">确定</el-button>
          <el-button @click="dialogRefund = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import mgr from '../../assets/js/securityapi';
import api from '../../assets/js/apiRequestHandler';
export default {
  data() {
    return {
      dialogConfig: false,
      dialogRefund: false,
      tableData: [],
      applicationUserId: '',
      form: {
        Id: '',
        MerchantId: '',
        PageNumber: 1,
        PageSize: 12,
        total: 0
      },
      rules: {
        money: [
          {
            required: true,
            message: '请输入金额',
            trigger: 'blur'
          }
        ]
      },
      refound: {
        money: ''
      },
      view: {}
    };
  },
  created() {
    this.getLists();
    this.getView();
  },
  methods: {
    async getLists() {
      let header = await mgr();
      for (let i in this.form) {
        if (this.form[i] === '') {
          delete this.form[i];
        }
      }
      api
        .get('/api/Paid/GetPaidAccountList', {
          headers: {
            Authorization: 'Bearer ' + header
          },
          params: this.form
        })
        .then(res => {
          if (res.status === 200) {
            this.form.total = JSON.parse(
              res.headers['x-pagination']
            ).TotalCount;
            this.tableData = res.data;
          }
        })
        .catch(err => {
          this.$messageError(err.message);
        });
    },
    async getView() {
      let header = await mgr();
      api
        .get('/api/Paid/GetPaidVersionInfo', {
          headers: {
            Authorization: 'Bearer ' + header
          },
          params: {}
        })
        .then(res => {
          if (res.status === 200) {
            this.view = res.data;
          }
        })
        .catch(err => {
          this.$messageError(err);
        });
    },
    search() {
      this.tableData = [];
      this.form.PageNumber = 1;
      console.log(this.form);
      this.getLists();
    },
    changePage(page) {
      console.log(page);
      this.tableData = [];
      this.form.PageNumber = page;
      this.getLists();
    },
    reset() {
      this.form = {
        Id: '',
        MerchantId: '',
        PageNumber: 1,
        PageSize: 0,
        total: 0
      };
      this.tableData = [];
      this.getLists();
    },
    async jinyong(index, row) {
      let header = await mgr();
      api
        .get('/api/Paid/ChangeUserState', {
          headers: {
            Authorization: 'Bearer ' + header
          },
          params: {
            userId: row.applicationUserId,
            userState: row.state === 1 ? 0 : 1
          }
        })
        .then(res => {
          if (res.status === 200) {
            this.$messageSuccess(res.data);
            this.getLists();
          }
        })
        .catch(err => {
          this.$messageError(err.message);
        });
    },
    async xiugai(index, row) {
      let header = await mgr();
      api
        .get('/api/Paid/ChangeSettlementState', {
          headers: {
            Authorization: 'Bearer ' + header
          },
          params: {
            userId: row.applicationUserId,
            userState: row.settlementType === 1 ? 0 : 1
          }
        })
        .then(res => {
          if (res.status === 200) {
            this.$messageSuccess(res.data);
            this.getLists();
          }
        })
        .catch(err => {
          this.$messageError(err.message);
        });
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.tuikuan();
        } else {
          return false;
        }
      });
    },
    async tuikuan() {
      let header = await mgr();
      api
        .get('/api/Paid/Refund', {
          headers: {
            Authorization: 'Bearer ' + header
          },
          params: {
            userId: this.applicationUserId,
            money: this.refound.money
          }
        })
        .then(res => {
          if (res.status === 200) {
            this.$messageSuccess(res.data);
          }
        })
        .catch(err => {
          this.$messageError(err.message);
        });
    },
    async handleCommand(command) {
      let header = await mgr();
      api
        .get('/api/Paid/ChangeUserType', {
          headers: {
            Authorization: 'Bearer ' + header
          },
          params: {
            userId: command.userid,
            paidAccountType: command.type
          }
        })
        .then(res => {
          if (res.status === 200) {
            this.$messageSuccess(res.data);
            this.getLists();
          }
        })
        .catch(err => {
          this.$messageError(err.message);
        });
    }
  }
};
</script>
<style></style>
<style scoped>
.gs_container {
  background-color: #fff;
}
</style>
